import { Plugin } from '../../types'

declare let window: Window

const context = null
const metadata = null
const extendedEventConfig = {
  media_heartbeat: { heartbeat_interval: 20 },
  media_seek: true,
}

const peachEventHandler = (): Plugin => {
  return (_jwPlayer, config) => {
    const props = {
      mediaApiUuid: config?.mediaStream?.uuid,
      mediaApiTimestamp: config?.mediaStream?.createdTimestamp,
    }

    const jwPlayerVideoElement = document.querySelector('.jw-video')

    if (config?.urAssetId && window._pc) {
      window._pc.trackMediaEvents(
        jwPlayerVideoElement,
        config.urAssetId,
        context,
        props,
        metadata,
        extendedEventConfig,
      )
    }
  }
}

export default peachEventHandler
